import { scroll as viemScroll } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const scroll = {
  displayName: 'Scroll',
  runtime: 'evm',
  viemChain: viemScroll,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'scroll' },
    qnStreams: {
      networkKey: 'scroll-mainnet',
    },
    pimlico: { chainSlug: 'scroll' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
